import type { ILaneConfig, LaneConfig, LaneThreshold, StoreControl } from 'commons';
import type { editModeViewEnum } from './editmode.types';

export class AddThreshold {
  static readonly type = '[EditMode] add Threshold';
  constructor(public readonly laneConfig: LaneConfig | ILaneConfig) {}
}
export class UpdateThreshold {
  static readonly type = '[EditMode] update Threshold';
  constructor(
    public readonly index: number,
    public readonly lane: LaneConfig | ILaneConfig,
    public readonly threshold: LaneThreshold
  ) {}
}
export class DeleteThreshold {
  static readonly type = '[EditMode] delete Threshold';
  constructor(public readonly index: number) {}
}

export class CloseSensorEditMode {
  static readonly type = '[Sensor Edit] close SensorEditmode';
}
export class OpenSensorEditmode {
  static readonly type = '[Sensor Edit] open SensorEditmode';
  constructor(public readonly control: StoreControl) {}
}
export class ApplySensorEditmode {
  static readonly type = '[Sensor Edit] apply SensorEditmode';
  constructor(public readonly control: StoreControl) {}
}
export class SetEditModeView {
  static readonly type = '[Editmode] set View';
  constructor(public readonly activeView: editModeViewEnum) {}
}
export class OpenedEditModeView {
  static readonly type = '[Editmode] opened View';
  constructor(public readonly activeView: editModeViewEnum) {}
}

export class SaveSensorEdit {
  static readonly type = '[Sensor Edit] save Sensor configuration';
  constructor(
    public readonly control: StoreControl,
    public readonly skipEditmode?: boolean
  ) {}
}

export class CloseEditmode {
  static readonly type = '[Editmode] close';
}
export class OpenEditmode {
  static readonly type = '[Editmode] open Editmode for Lane';
  constructor(public readonly laneConfig: LaneConfig | ILaneConfig) {}
}

export class SetYAxisPanelState {
  static readonly type = '[Editmode] set Y Axis Panel State';
  constructor(public readonly id?: string | null) {}
}

export class PinEditmode {
  static readonly type = '[Editmode] pin Editmode';
}
export class UnpinEditmode {
  static readonly type = '[Editmode] unpin Editmode';
}
export class ToggleDirection {
  static readonly type = '[Editmode] toggle Direction';
}

export class SetHightlightComment {
  static readonly type = '[Editmode] set highlight comment';
  constructor(public readonly commentId: string | null) {}
}
